// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__s4fH0","icon":"styles_icon__XkiUq"};